export default __webpack_public_path__ + "static/SatangPro _Logo Member TFA-5c555d982ff0ba7b3bdd91041f98ece2.png";